<template>
	<MStateBox :loading="offline.loading" :empty="isEmpty" class="offline">
		<CMobileScroll pullDown @pull-down="onPullDown" pullUp :moreData="hasMoreData" @pull-up="onPullUp">
			<div class="offline-list">
				<div class="offline-box-item" v-for="item in finalData" :key="item.id" @click="handleClick(item)">
					<p class="offline-title text-overflow2">{{ item.title }}</p>

					<div class="offline-bottom">
						<div class="offline-status">
							<span class="offline-btn inactive-btn" v-if="item.activitystatusdesc === '已结束'">
								已结束
							</span>
							<span v-else class="offline-btn active-btn">进行中</span>
							<span class="offline-organizers">{{ item.organizers }}</span>
						</div>
						<p class="offline-time">{{ dateFormatYearMonthDate(item.stime) }}</p>
					</div>
				</div>
			</div>
		</CMobileScroll>
	</MStateBox>
</template>

<script setup>
import { computed, onMounted } from 'vue';
import { dateFormatYearMonthDate } from '@/utils/format';
import { useModuleData } from '@rebuild/hooks/data/useModuleData';
import { useModuleNavigation } from '@rebuild/hooks/useModuleNavigation';
import { usePaginationMobile } from '@rebuild/hooks/load-more/usePaginationMobile';
import MStateBox from '@rebuild/components/MStateBox.vue';

const { offline } = useModuleData();
const isEmpty = computed(() => {
	return finalData.value.length === 0 && !offline.loading;
});
const refreshOffline = async () => {
	await offline.refresh({
		pageStart: currentPage.value - 1,
		pageNum: pageSize.value
	});

	const data = offline.data?.data || [];
	const total = offline.data?.total || 0;
	setData(data, total);
};

onMounted(() => {
	refreshOffline();
});

const {
	currentPage,
	pageSize,
	finalData,
	setData,
	hasMoreData,
	onPullDown,
	onPullUp
} = usePaginationMobile({
	bindChange: refreshOffline
});

const { viewModule } = useModuleNavigation();
const handleClick = item => {
	return viewModule('offline', item);
};
</script>

<style lang="less" scoped>
.offline {
	padding: 0 16px;
	height: 100%;
	.offline-box-item {
		padding: 12px 0 16px 0;
		border-bottom: 1px solid var(--border-lighter-color, #f2f3f5);

		.offline-title {
			color: var(--t-emphasis-color, #1d2129);

			font-size: 16px;

			font-weight: 500;
			line-height: 24px; /* 150% */
		}
		.offline-bottom {
			display: flex;
			justify-content: space-between;
			margin-top: 8px;
			height: 18px;
			.offline-btn {
				margin-right: 8px;
				padding: 0 4px;
				display: inline-flex;
				align-items: center;

				font-weight: 400;
				font-size: 10px;
				line-height: 18px;
			}
			.active-btn {
				background: linear-gradient(0deg, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0.9) 100%), #f26a3d;
				color: #f26a3d;
			}
			.inactive-btn {
				background-color: #f2f3f5;
				color: #4e5969;
			}
			.offline-organizers {
				color: var(---gray-5, #999);

				font-size: 12px;
			}
			.offline-time {
				color: var(--t-secondary-info-color, #86909c);
				text-align: right;

				font-size: 13px;
			}
		}
	}

	.offline-box-item:first-child {
		padding-top: 4px;
	}
	.offline-box-item:last-child {
		border: none;
	}
}
</style>
